import { diaryNewTrackerEntryPagePath } from "@/features/diaries/routes";
import { getFormSlugDisplayLabel } from "@/features/diaries/utils/displayLabels";
import { scheduleStepDisplayLabel } from "@/features/entries/services/timingLabelDerivation";
import { getDiaryCopy } from "@/features/i18n/diaryCopy";
import { DEFAULT_LOCALE, type SupportedLocale } from "@patient-watch/i18n";
import { v4 as uuidv4 } from "uuid";

import { findEarliestDueFormItem } from "../../../utils/findEarliestDueEntry";
import type { FormsToDoItem } from "../hooks/useFormsToDo";

export interface NextDueEntryAction {
    buttonLabel: string;
    isLocked: boolean;
    to: string;
    params: Record<string, string>;
    scheduleLabel: string;
}

export function findFirstDueEntryAction(
    diaryId: string,
    toDoItems: FormsToDoItem[],
    locale: SupportedLocale = DEFAULT_LOCALE
): NextDueEntryAction | null {
    const earliest = findEarliestDueFormItem(toDoItems);
    if (!earliest) {
        return null;
    }

    const { item, dueEntry } = earliest;
    const entryId = uuidv4();
    const isLocked = dueEntry.is_locked === true;
    const scheduleLabel = scheduleStepDisplayLabel(dueEntry, locale);
    const formSlug =
        locale !== DEFAULT_LOCALE && item.data.form?.form_name
            ? item.data.form.form_name
            : getFormSlugDisplayLabel(item.data.form, item.name || "Questionnaire");

    return {
        buttonLabel: getDiaryCopy(locale).addEntryFor(formSlug, scheduleLabel),
        isLocked,
        scheduleLabel,
        to: diaryNewTrackerEntryPagePath,
        params: {
            diaryId,
            trackerId: item.data.tracker_id,
            entryId,
            pageIndex: "1",
        },
    };
}
